import { SiArtstation, SiDeviantart, SiFiverr } from "react-icons/si";
import "./art.css";

const Art = () => {
  const images = [
    { path: "/art", fileName: "img1", extension: "jpg" },
    { path: "/art", fileName: "img2", extension: "png" },
    { path: "/art", fileName: "img3", extension: "png" },
    { path: "/art", fileName: "img4", extension: "png" },
    { path: "/art", fileName: "img12", extension: "png" },
    { path: "/art", fileName: "img9", extension: "png" },
    { path: "/art", fileName: "img6", extension: "png" },
    { path: "/art", fileName: "img10", extension: "png" },
    { path: "/art", fileName: "img5", extension: "png" },
    { path: "/art", fileName: "img7", extension: "png" },
    { path: "/art", fileName: "img8", extension: "png" },
    { path: "/art", fileName: "img11", extension: "png" },
  ];

  return (
    <>
      <div className="artContainer">
        <h1 className="artHead fadeRight">Checkout my artwork!</h1>
        <div className="artLinks fadeLeft">
          <a
            href="https://www.artstation.com/electricpants"
            className="artLink"
            target="_blank"
            rel="noreferrer"
          >
            <span>Artstation</span>
            <SiArtstation className="artIcon" />
          </a>
          <a
            href="https://www.deviantart.com/sonu9/gallery/all"
            className="artLink"
            target="_blank"
            rel="noreferrer"
          >
            <span>DeviantArt</span>
            <SiDeviantart className="artIcon" />
          </a>
          <a
            href="https://www.fiverr.com/artmyth"
            className="artLink"
            target="_blank"
            rel="noreferrer"
          >
            <span>Fiverr</span>
            <SiFiverr className="fivIcon" />
          </a>
        </div>

        <div className="artImgContainer">
          {images.map((image, i) => (
            <a
              href={`${process.env.PUBLIC_URL}${image.path}/${image.fileName}.${image.extension}`}
              target="_blank"
              key={i}
              rel="noreferrer"
            >
              <img
                src={`${process.env.PUBLIC_URL}${image.path}/${image.fileName}-min.${image.extension}`}
                alt="art"
                className="artImg fadeUp"
                style={{ animationDelay: `${i + 1}00ms` }}
              />
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default Art;
